var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const FALLBACK_LOCALE = "en_gb";
let translations = {};
export const translate = (key, substitutions) => {
    let translation = translations[key];
    if (!translation) {
        console.error(`Translation missing: ${key}`);
        return key;
    }
    if (!substitutions) {
        return translation;
    }
    Object.keys(substitutions).forEach((substitution) => {
        translation = translation.replace(`{{${substitution}}}`, substitutions[substitution]);
    });
    return translation;
};
const fallbackTranslationRequest = (config, context, locale) => __awaiter(void 0, void 0, void 0, function* () {
    if (config.staticTranslationUrl === undefined) {
        throw new Error("Static fallback translations error: path not configured");
    }
    const fileName = locale !== null && locale !== void 0 ? locale : FALLBACK_LOCALE;
    const staticFallbackJsonPath = `${config.staticTranslationUrl}${context}/${fileName.toLowerCase()}.json`;
    try {
        const response = yield fetch(staticFallbackJsonPath);
        if (!response.ok) {
            throw new Error(`Requested fallback translation not found: ${context}/${fileName}`);
        }
        return yield response.json();
    }
    catch (e) {
        if (locale !== FALLBACK_LOCALE) {
            return yield fallbackTranslationRequest(config, context, FALLBACK_LOCALE);
        }
        else {
            throw new Error("Static fallback language not found: " + context);
        }
    }
});
const translationApiRequest = (config, context, locale, originalLocale) => __awaiter(void 0, void 0, void 0, function* () {
    const targetLocale = locale.toLowerCase() === "nb_no" ? "no_no" : locale;
    const localizationUrl = `${config.translationApiUrl}?locale=${targetLocale}&context=${context}&style=dotted`;
    try {
        const response = yield fetch(localizationUrl);
        if (!response.ok) {
            throw new Error(`Requested language not found (${locale})`);
        }
        return yield response.json();
    }
    catch (e) {
        if (locale !== FALLBACK_LOCALE) {
            return yield translationApiRequest(config, context, FALLBACK_LOCALE, locale);
        }
        else {
            return yield fallbackTranslationRequest(config, context, originalLocale);
        }
    }
});
export const loadTranslations = (config, dependencies, locale) => __awaiter(void 0, void 0, void 0, function* () {
    const combinedContexts = dependencies.translations;
    config.modules.forEach((module) => {
        if (module.translationContext === undefined || module.translationContext === "") {
            return;
        }
        module.translationContext.split(",").forEach((context) => {
            combinedContexts.add(context);
        });
    });
    if (combinedContexts.size === 0) {
        return {};
    }
    const localeToLoad = (locale !== null && locale !== void 0 ? locale : FALLBACK_LOCALE).toLowerCase();
    const contextTranslations = yield Promise.all([...combinedContexts].map((context) => __awaiter(void 0, void 0, void 0, function* () {
        return translationApiRequest(config, context, localeToLoad);
    })));
    translations = contextTranslations.reduce((acc, current) => (Object.assign(Object.assign({}, acc), current)));
    return translations;
});
